import $api from "@/axios/request"
import router from "@/router";

export default {
    namespaced: true,
    state() {
        return {
            requests: [],
            users: []
        }
    },
    mutations: {
        setRequests(state, requests) {
            state.requests = requests
        },
        setAuthUsers(state, users) {
            state.users = users
        },
    },
    actions: {
        async saveRequest({commit, dispatch}, payload) {
            try {
                await $api.post('http://213.139.209.236:5000/api/saveRequest', payload)
                dispatch('setMessage', {
                    value: 'Заявка успешно отправлена',
                    type: 'primary'
                }, {root: true})
            }
            catch (e) {
                dispatch('setMessage', {
                    value: e.response.data.message,
                    type: 'danger'
                }, {root: true})
                throw new Error(e)
            }
        },

        async getRequests({commit, dispatch}) {
            try {
                const {data} = await $api.get('http://213.139.209.236:5000/api/getRequests')
                commit('setRequests', data)
            }
            catch (e) {
                dispatch('setMessage', {
                    value: e.response.data.message,
                    type: 'danger'
                }, {root: true})
                throw new Error(e)
            }
        },

        async getAuthUsers({commit, dispatch}) {
            try {
                const {data} = await $api.get('http://213.139.209.236:5000/api/getAuthUsers')
                commit('setAuthUsers', data)
            }
            catch (e) {
                dispatch('setMessage', {
                    value: e.response.data.message,
                    type: 'danger'
                }, {root: true})
                throw new Error(e)
            }
        },

        async removeRequest({commit, dispatch}, id) {
            try {
                await $api.post('http://213.139.209.236:5000/api/removeRequest', id)
                dispatch('setMessage', {
                    value: 'Заявка удалена',
                    type: 'primary'
                }, {root: true})
            }
            catch (e) {
                dispatch('setMessage', {
                    value: e.response.data.message,
                    type: 'danger'
                }, {root: true})
                throw new Error(e)
            }
        },

        async removeUser({commit, dispatch}, id) {
            try {
                await $api.post('http://213.139.209.236:5000/api/removeUser', id)
                dispatch('setMessage', {
                    value: 'Пользователь удалён',
                    type: 'primary'
                }, {root: true})
            }
            catch (e) {
                dispatch('setMessage', {
                    value: e.response.data.message,
                    type: 'danger'
                }, {root: true})
                throw new Error(e)
            }
        },

        async updateUser({commit, dispatch}, payload) {
            try {
                await $api.put('http://213.139.209.236:5000/api/updateUser', payload)
                dispatch('setMessage', {
                    value: 'Данные обновлены',
                    type: 'primary'
                }, {root: true})
            }
            catch (e) {
                dispatch('setMessage', {
                    value: e.response.data.message,
                    type: 'danger'
                }, {root: true})
                throw new Error(e)
            }
        },

        async createExcel({commit, dispatch}, payload) {
            try {
                await $api.post('http://213.139.209.236:5000/api/createExcel', payload)
                dispatch('setMessage', {
                    value: 'excel создан',
                    type: 'primary'
                }, {root: true})
            }
            catch (e) {
                dispatch('setMessage', {
                    value: e.response.data.message,
                    type: 'danger'
                }, {root: true})
                throw new Error(e)
            }
        },
    },

    getters: {
        requests(state) {
            return state.requests
        },
        users(state) {
            return state.users
        },
    }

}